import { PosthogManager } from "@v2/shared/lib/posthog/posthog";
import { RouteObject } from "react-router";
import React from "react";
import { TrelloIframeClientManager } from "@v2/shared/api/trello";
import { boardDataStoreQuery } from "@v2/entities/trello/boards/boards.queries";
import { prodLog } from "@v2/shared/lib/logger";
import { MainContentGuard } from "./wraps/mainContentGuard.wrap";
// import { createIframeConnectorRoutes } from "./iframeConnectorRoutes.fact";

// AIDEV-NOTE: Feature flag controls routing structure at app level
export const createPaywallRoutes = () =>
  [
    // ...createIframeConnectorRoutes("/iframeConnector-2"),
    {
      loader: () => {
        // AIDEV-NOTE: this does not do anything right now, since the AuthorizePage is using the old trello client
        prodLog("IframeConsumer: authorize", {
          hasTrelloPowerUp:
            typeof window.TrelloPowerUp?.initialize === "function",
        });
        TrelloIframeClientManager.markAsConsumerContext();
      },
      path: "authorize",
      element: <AuthorizePage />,
      // hydrateFallbackElement: <LoaderPage />,
      hydrateFallbackElement: <></>,
    },
    {
      path: "/",
      loader: () => {
        prodLog("IframeConsumer: modal loader", {
          hasTrelloPowerUp:
            typeof window.TrelloPowerUp?.initialize === "function",
        });
        PosthogManager.startSessionRecording();
        TrelloIframeClientManager.markAsConsumerContext();
        boardDataStoreQuery.prefetch().catch(() => undefined);
      },
      hydrateFallbackElement: <></>,
      element: <MainContentGuard />,
      children: [
        {
          path: "modal",
          element: <ModalPage />,
        },
        {
          // aha: avoid deeply nested routes such as {"path": "/modal", "children": {"path": "/modal/profile"}}
          // In this scenario, when going outside of the /modal* path the whole tree, including the /modal will be unmounted,
          // which can be computationally expensive
          path: "modal/profile",
          element: <ProfileDashboard returnUrl="/modal" />,
        },
        {
          path: "modal/pricing",
          element: <PricingDashboard returnUrl="/modal" />,
        },
        {
          path: "createProfile",
          element: <CreateProfile />,
        },
        {
          path: "noBoardAccess",
          element: <NoBoardAccess />,
        },
      ],
    },
  ] satisfies RouteObject[];

const ProfileDashboard = React.lazy(() =>
  import("@v2/features/paywall").then((module) => ({
    default: module.ProfileDashboard,
  }))
);

const CreateProfile = React.lazy(() =>
  import("@v2/features/paywall").then((module) => ({
    default: module.CreateProfile,
  }))
);

const PricingDashboard = React.lazy(() =>
  import("@v2/features/paywall").then((module) => ({
    default: module.PricingDashboard,
  }))
);

const NoBoardAccess = React.lazy(() =>
  import("@v2/features/paywall/noBoardAccess.ui").then((module) => ({
    default: module.NoBoardAccess,
  }))
);

// AIDEV-NOTE: Needs to be loaded lazily, so that iframe is initialized first
const ModalPage = React.lazy(() =>
  import("@v2/pages/modal/modalPage").then((module) => ({
    default: module.ModalPage,
  }))
);

// AIDEV-NOTE: Needs to be loaded lazily, so that iframe is initialized first
const AuthorizePage = React.lazy(() =>
  import("@v2/pages/authorize/authorizePage").then((module) => ({
    default: module.AuthorizePage,
  }))
);
